<form
  class="update-record-dialog"
  [formGroup]="hotkeyForm"
  (ngSubmit)="updateHotkey()"
>
  <section class="record-summary" aria-label="Hotkey context">
    <div class="record-summary__icon" aria-hidden="true">
      <i class="pi pi-bolt"></i>
    </div>

    <div class="record-summary__copy">
      <span class="record-summary__eyebrow">Edit Hotkey</span>
      <h2>{{ hotkeyForm.get('hotkey_main')?.value || 'Hotkey details' }}</h2>
    </div>
  </section>

  <section class="form-section">
    <div class="form-section__header">
      <h3>Hotkey details</h3>
    </div>

    <div class="form-grid">
      <div class="form-field">
        <label for="hotkeyMain">Main Hotkey</label>
        <input
          id="hotkeyMain"
          pInputText
          type="text"
          formControlName="hotkey_main"
          maxlength="6"
          class="w-full"
        />
        <small
          class="p-error"
          *ngIf="hotkeyForm.get('hotkey_main')?.hasError('required') && (hotkeyForm.get('hotkey_main')?.touched || hotkeyForm.get('hotkey_main')?.dirty)"
        >
          <strong>A main hotkey</strong> is required
        </small>
        <small
          class="p-error"
          *ngIf="hotkeyForm.get('hotkey_main')?.hasError('maxlength')"
        >
          Main hotkey must be 6 characters or fewer
        </small>
      </div>

      <div class="form-field">
        <label for="mainDescription">Hotkey Description</label>
        <input
          id="mainDescription"
          pInputText
          type="text"
          formControlName="main_description"
          maxlength="30"
          class="w-full"
        />
        <small
          class="p-error"
          *ngIf="hotkeyForm.get('main_description')?.hasError('required') && (hotkeyForm.get('main_description')?.touched || hotkeyForm.get('main_description')?.dirty)"
        >
          <strong>A hotkey description</strong> is required
        </small>
        <small
          class="p-error"
          *ngIf="hotkeyForm.get('main_description')?.hasError('maxlength')"
        >
          Description must be 30 characters or fewer
        </small>
      </div>
    </div>
  </section>

  <div class="dialog-actions">
    <button
      pButton
      type="submit"
      icon="pi pi-check"
      label="Update Hotkey"
      class="p-button-primary w-full"
      [loading]="loading"
    ></button>
  </div>
</form>
